/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Choose_ClientInputs */

const fr_validation_choose_client = /** @type {(inputs: Validation_Choose_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un client disponible.`)
};

const en_validation_choose_client = /** @type {(inputs: Validation_Choose_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose an available client.`)
};

/**
* | output |
* | --- |
* | "Choose an available client." |
*
* @param {Validation_Choose_ClientInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_choose_client = /** @type {((inputs?: Validation_Choose_ClientInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Choose_ClientInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_choose_client(inputs)
	return fr_validation_choose_client(inputs)
});